module.exports = __webpack_public_path__ + "static/media/push-ups.819d0249.svg";